import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AddMedicine.css';
import JoditEditor from 'jodit-react';

const AddMedicine = () => {
  const [name, setName] = useState('');
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);
  const [packOf, setPackOf] = useState('');
  const [batchNumber, setBatchNumber] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [mrp, setMrp] = useState('');
  const [salePrice, setSalePrice] = useState('');
  const [stockQuantity, setStockQuantity] = useState('');
  const [free, setFree] = useState('');
  const [dealPriceChecked, setDealPriceChecked] = useState(false);
  const [brand, setBrand] = useState('');
  const [salt, setSalt] = useState('');
  const [gst, setGst] = useState('');
  const [categories, setCategories] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('https://api.swasthmitra.com/api/category/get');
        setCategories(response.data.categories);
      } catch (err) {
        console.error('Error fetching categories:', err);
      }
    };

    const fetchDepartments = async () => {
      try {
        const response = await axios.get('https://api.swasthmitra.com/api/category/selected');
        setDepartments(response.data.categories);
      } catch (err) {
        console.error('Error fetching departments:', err);
      }
    };

    fetchCategories();
    fetchDepartments();
  }, []);

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setImages([...images, ...selectedFiles]);
  };

  const handleDepartmentChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedDepartments([...selectedDepartments, value]);
    } else {
      setSelectedDepartments(selectedDepartments.filter((dept) => dept !== value));
    }
  };

  // Function to delete an image
  const deleteImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
  };

  const freeValue = parseInt(free) || 0;
  const packOfValue = parseInt(packOf) || 0;
  const salePriceValue = parseFloat(salePrice) || 0;
  const calculatedDealRate = dealPriceChecked
    ? salePriceValue * (packOfValue / (packOfValue + freeValue))
    : salePriceValue;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('name', name);
    formData.append('category', category);
    formData.append('description', description);
    formData.append('packOf', packOf);
    formData.append('batchNumber', batchNumber);
    formData.append('expiryDate', expiryDate);
    formData.append('mrp', mrp);
    formData.append('salePrice', salePrice);
    formData.append('stockQuantity', stockQuantity);
    formData.append('dealRate', calculatedDealRate);
    formData.append('brand', brand);
    formData.append('salt', salt);
    formData.append('gst', gst);
    selectedDepartments.forEach((dept) => formData.append('department[]', dept));
    images.forEach((image) => formData.append('images', image));

    try {
      const response = await axios.post('https://api.swasthmitra.com/api/medicine/add', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setMessage(response.data.message);
      setName('');
      setCategory('');
      setSelectedDepartments([]);
      setDescription('');
      setPackOf('');
      setBatchNumber('');
      setExpiryDate('');
      setMrp('');
      setSalePrice('');
      setStockQuantity('');
      setFree('');
      setBrand('');
      setSalt('');
      setGst('');
      setDealPriceChecked(false);
      setImages([]);
      e.target.reset();
    } catch (err) {
      setMessage('Error adding medicine');
      console.error('Error:', err);
    }
  };

  return (
    <div className="add-medicine-container">
      <h2>Add Medicine</h2>
      <form onSubmit={handleSubmit}>
        <input type="text" placeholder="Name*" value={name} onChange={(e) => setName(e.target.value)} required />

        <fieldset style={{ border: '1px solid #ccc', padding: '15px', borderRadius: '8px' }}>
          <legend style={{ fontWeight: 'bold', fontSize: '1.1rem', marginBottom: '10px' }}>Select Departments:</legend>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px 20px' }}>
            {departments.map((dept, index) => (
              <label key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '1rem', marginBottom: '10px' }}>
                <input
                  type="checkbox"
                  value={dept.slug || dept.name}
                  checked={selectedDepartments.includes(dept.slug || dept.name)}
                  onChange={handleDepartmentChange}
                />
                {dept.name}
              </label>
            ))}
          </div>
        </fieldset>

        <select value={category} onChange={(e) => setCategory(e.target.value)} required>
          <option value="">Select Category</option>
          {categories.map((cat, index) => (
            <option key={index} value={cat.slug || cat.name}>
              {cat.name}
            </option>
          ))}
        </select>

        <JoditEditor value={description} onChange={(newContent) => setDescription(newContent)} />
        <input type="text" placeholder="Pack Of*" value={packOf} onChange={(e) => setPackOf(e.target.value)} required />
        <input type="text" placeholder="Batch Number*" value={batchNumber} onChange={(e) => setBatchNumber(e.target.value)} required />
        <input type="date" placeholder="Expiry Date" value={expiryDate} onChange={(e) => setExpiryDate(e.target.value)} />
        <input type="number" placeholder="MRP*" value={mrp} onChange={(e) => setMrp(e.target.value)} required />
        <input type="number" placeholder="Sale Price*" value={salePrice} onChange={(e) => setSalePrice(e.target.value)} required />
        <input type="number" placeholder="Stock Quantity*" value={stockQuantity} onChange={(e) => setStockQuantity(e.target.value)} required/>
        <input type="text" placeholder="Brand" value={brand} onChange={(e) => setBrand(e.target.value)} />
        <input type="text" placeholder="Salt Name" value={salt} onChange={(e) => setSalt(e.target.value)} />
        <input type="number" placeholder="GST*" value={gst} onChange={(e) => setGst(e.target.value)} required />

        <label>
          <input type="checkbox" checked={dealPriceChecked} onChange={() => setDealPriceChecked(!dealPriceChecked)} />
          Apply Deal
        </label>

        {dealPriceChecked && <input type="number" placeholder="Free" value={free} onChange={(e) => setFree(e.target.value)} />}

        <input type="file" multiple onChange={handleFileChange} />
        <div className="image-preview">
          {images.length > 0 &&
            images.map((image, index) => (
              <div key={index} style={{ position: 'relative', display: 'inline-block', margin: '10px' }}>
                <img src={URL.createObjectURL(image)} alt={`Preview ${index + 1}`} style={{ width: '100px' }} />
                <button
                  onClick={() => deleteImage(index)}
                  style={{
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    background: 'red',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    padding: '2px 6px',
                  }}
                >
                  X
                </button>
              </div>
            ))}
        </div>
        <button type="submit">Add Medicine</button>
      </form>
      {message && <p style={{ color: message.includes('Error') ? 'red' : 'green', textAlign: 'center', marginTop: '15px' }}>{message}</p>}
    </div>
  );
};

export default AddMedicine;